import { defineMessages } from 'react-intl';

/** The copy of the campaign screen (design "Outreach Momentum" t1, t6) and the reply toast (t2). */
export const liveMessages = defineMessages({
  working: { id: 'app.outreach.live.search.working', defaultMessage: 'Plug is working' },
  searchTitle: { id: 'app.outreach.live.search.title', defaultMessage: 'Plug is looking for curators who fit {song}' },
  writingTitle: {
    id: 'app.outreach.live.search.writingTitle',
    defaultMessage: 'Plug writes a pitch for each curator who fits {song}',
  },
  reviewTitle: { id: 'app.outreach.live.search.reviewTitle', defaultMessage: 'Your pitches for {song} are ready' },
  searchBody: {
    id: 'app.outreach.live.search.body',
    defaultMessage:
      'It reads your sound, finds the playlists, blogs and radio shows that play artists like you, and checks who can get an email.',
  },
  stepsTitle: { id: 'app.outreach.live.steps.title', defaultMessage: 'What Plug does now' },
  stepSound: { id: 'app.outreach.live.steps.sound', defaultMessage: 'Read your sound' },
  stepSimilar: { id: 'app.outreach.live.steps.similar', defaultMessage: 'Found similar artists' },
  stepSimilarSub: { id: 'app.outreach.live.steps.similarSub', defaultMessage: 'From your listeners and playlists' },
  stepScan: { id: 'app.outreach.live.steps.scan', defaultMessage: 'Scanning playlists that play them' },
  stepScanSub: { id: 'app.outreach.live.steps.scanSub', defaultMessage: 'Spotify, Apple Music, Deezer' },
  stepContacts: { id: 'app.outreach.live.steps.contacts', defaultMessage: 'Checking who has an email' },
  stepContactsSub: { id: 'app.outreach.live.steps.contactsSub', defaultMessage: 'Public pages only' },
  stepWrite: { id: 'app.outreach.live.steps.write', defaultMessage: 'Writing a pitch for each person' },
  stepWriteSub: { id: 'app.outreach.live.steps.writeSub', defaultMessage: 'You read them before they go' },
  stepSend: { id: 'app.outreach.live.steps.send', defaultMessage: 'Contacting them slowly' },
  stepSendSub: { id: 'app.outreach.live.steps.sendSub', defaultMessage: 'From your own mailbox' },
  stepGenres: {
    id: 'app.outreach.live.steps.genres',
    defaultMessage: '{count, plural, one {# genre} other {# genres}}',
  },
  stepOfTotal: { id: 'app.outreach.live.steps.ofTotal', defaultMessage: '{count} / {total}' },
  stepDone: { id: 'app.outreach.live.steps.stateDone', defaultMessage: 'Done' },
  stepNow: { id: 'app.outreach.live.steps.stateNow', defaultMessage: 'Now' },
  stepWait: { id: 'app.outreach.live.steps.stateWait', defaultMessage: 'Next' },
  yourSound: { id: 'app.outreach.live.sound.title', defaultMessage: 'Your sound' },
  likeArtist: { id: 'app.outreach.live.sound.like', defaultMessage: 'Like {name}' },
  matchesTitle: { id: 'app.outreach.live.matches.title', defaultMessage: 'Curators who fit {song}' },
  foundSoFar: { id: 'app.outreach.live.matches.foundSoFar', defaultMessage: '{count} found so far' },
  bestFitFirst: { id: 'app.outreach.live.matches.bestFitFirst', defaultMessage: 'Best fit first' },
  justFound: { id: 'app.outreach.live.matches.justFound', defaultMessage: 'Just found' },
  emailFound: { id: 'app.outreach.live.matches.emailFound', defaultMessage: 'Email found' },
  followers: { id: 'app.outreach.live.matches.followers', defaultMessage: '{count} followers' },
  playlistsLeft: {
    id: 'app.outreach.live.matches.playlistsLeft',
    defaultMessage: 'Plug checks {count, plural, one {# more playlist} other {# more playlists}}',
  },
  noMatchesYet: {
    id: 'app.outreach.live.matches.none',
    defaultMessage: 'The first curators show here as soon as Plug finds them.',
  },
  nothingYet: {
    id: 'app.outreach.live.search.nothingYet',
    defaultMessage: 'Nothing goes out yet. You read each pitch first, then Plug sends them slowly from {mailbox}.',
  },
  nothingYetNoMailbox: {
    id: 'app.outreach.live.search.nothingYetNoMailbox',
    defaultMessage:
      'Nothing goes out yet. You read each pitch first, then Plug sends them slowly from your own mailbox.',
  },
  pause: { id: 'app.outreach.live.pause', defaultMessage: 'Pause' },
  reviewReady: {
    id: 'app.outreach.live.review.ready',
    defaultMessage: 'Plug wrote {count, plural, one {# pitch} other {# pitches}}. Read them, then Plug starts sending.',
  },
  reviewOpen: { id: 'app.outreach.live.review.open', defaultMessage: 'Read the pitches' },
  replyToastTitle: { id: 'app.outreach.live.toast.title', defaultMessage: '{name} replied · {label}' },
  replyToastAction: { id: 'app.outreach.live.toast.action', defaultMessage: 'Read and answer' },
  quoted: { id: 'app.outreach.live.quoted', defaultMessage: '"{text}"' },
});
